export default __webpack_public_path__ + "288cf1291e3898de6e925d3fe9090665.svg";